module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "preview-section",
    style: (_vm.rgba_color)
  }, [_c('preview', {
    attrs: {
      "step": _vm.step,
      "custom_color": _vm.color
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-section",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.to_step(_vm.step + 1)
      }
    }
  }, [(_vm.step === 0) ? _c('step-0', {
    attrs: {
      "email": _vm.email,
      "invalid": _vm.invalid
    },
    on: {
      "change_value": _vm.change_email
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step === 1) ? _c('step-1', {
    attrs: {
      "name": _vm.name,
      "invalid": _vm.invalid
    },
    on: {
      "change_value": _vm.change_name
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('step-2', {
    attrs: {
      "description": _vm.description,
      "invalid": _vm.invalid
    },
    on: {
      "change_value": _vm.change_description
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step === 3) ? _c('step-3', {
    attrs: {
      "custom_color": _vm.color,
      "invalid": _vm.invalid
    },
    on: {
      "change_color": _vm.change_color
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step === 4) ? _c('step-4', {
    attrs: {
      "currency": _vm.currency,
      "invalid": _vm.invalid
    },
    on: {
      "change_value": _vm.change_currency
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step === 5) ? _c('step-5', {
    attrs: {
      "password": _vm.password,
      "invalid": _vm.invalid
    },
    on: {
      "change_value": _vm.change_password
    }
  }) : _vm._e(), _vm._v(" "), (_vm.generic_error) ? _c('p', {
    staticClass: "form-error"
  }, [_vm._v(_vm._s(_vm.generic_error))]) : _vm._e(), _vm._v(" "), _c('action-buttons', {
    attrs: {
      "step": _vm.step
    },
    on: {
      "step": _vm.to_step
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-148b9280"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 68
// module chunks = 0